import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BoxLogo = styled(Box)<BoxProps>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    justifyContent: "flex-start",
    padding: theme.spacing(2.5),
    textAlign: "center",
    ".logo": {
      width: 200,
      maxWidth: "70vw",
    },
    ".avatar": {
      display: "none",
    },
    ".slogan": {
      display: "none",
    },
    "&.has-results": {
      padding: theme.spacing(1.5, 2, 1.25),
      ".logo": {
        width: 130,
      },
    },
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: 340,
    marginLeft: 48,
    marginRight: 48,
    height: "100vh",
  },
}));
